/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-06 21:13:20
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-08 19:58:42
 * @FilePath: /roboneo-web/src/store/useCursorStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';
import {
  MoveCanvasOfDefault,
  RenderCursor,
  CoreMouseMode,
  MovecanvasOfInsertFrame,
  Point,
} from '@meitu/whee-infinite-canvas';
import useCanvasStore from '$/store/useCanvasStore';

export enum CursorType {
  Select = 'select',
  Drag = 'drag',
  Text = 'text',
  Frame = 'frame',
  Asset = 'asset',
}

interface TCursorState {
  activeCursor: CursorType;
}

const cursorSlice: StateCreator<TCursorState, [
  ['zustand/immer', never],
]> = () => ({
  activeCursor: CursorType.Select,
});

const useCursorStore: UseBoundStore<StoreApi<TCursorState>> = create<TCursorState>()(immer(cursorSlice));

export default useCursorStore;

/**
 * 设置光标状态
 *
 * @export
 * @param {CursorType} val
 * @param {boolean} [isRecordPre=true]
 */
export function setActiveCursor(val: CursorType) {
  useCursorStore.setState(() => ({
    activeCursor: val,
  }));
}

/**
 * 选择模式
 *
 * @export
 * @return {*}
 */
export function setSelectCursor() {
  const { activeCursor } = useCursorStore.getState();
  const { render, renderStyle } = useCanvasStore.getState();
  setActiveCursor(CursorType.Select);
  const setHover = () => {
    renderStyle?.setCursorStyle({
      move: RenderCursor.default,
      hover: RenderCursor.hover,
      defaults: RenderCursor.default,
      mousedown: RenderCursor.default,
    });
  };

  if (activeCursor !== CursorType.Select) {
    setHover();
    render?.unlockAllAndUnListenMove();
  }
}

/**
 * 拖拽模式
 *
 * @export
 * @return {*}
 */
export function setDragCursor(poiner?: Point) {
  const { activeCursor } = useCursorStore.getState();
  const { render, renderStyle } = useCanvasStore.getState();
  setActiveCursor(CursorType.Drag);
  const setMove = () => {
    renderStyle?.setCursorStyle({
      move: MoveCanvasOfDefault,
      hover: MoveCanvasOfDefault,
      defaults: MoveCanvasOfDefault,
      mousedown: RenderCursor.mousedown,
    });
  };
  if (activeCursor !== CursorType.Drag) {
    setMove();
    render?.lockAllAndListenMove(poiner);
  }
}

/**
 * 改字编辑十字光标
 *
 * @export
 */
export function setFrameCursor() {
  const { activeCursor } = useCursorStore.getState();
  const { render, renderStyle } = useCanvasStore.getState();
  if (activeCursor !== CursorType.Frame) {
    setActiveCursor(CursorType.Frame);
    renderStyle?.setCursorStyle({
      move: MovecanvasOfInsertFrame,
      hover: MovecanvasOfInsertFrame,
      defaults: MovecanvasOfInsertFrame,
    });
    render?.unlockAllAndUnListenMove();
  }
}
